// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, anyOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

/** CJ OliveNetworks credential validator */
const isCjKakaoSenderKey = objectOf({
  id: string,
  provider: string,
  credential_name: string,
  sender_key: string,
  sender_number: string,
  authorization: string,
  channel_name: maybe(string),
  channel_uuid: maybe(string),
  url: string,
});

/** Infobip credential validator */
const isInfobipKakaoSenderKey = objectOf({
  id: string,
  provider: string,
  api_key: string,
  url: string,
  sender_key: string,
  channel_name: maybe(string),
  channel_uuid: maybe(string),
});

export const isEngagementAppGroupIdKakaoSenderKeysResult = arrayOf(
  anyOf(isCjKakaoSenderKey, isInfobipKakaoSenderKey)
);
